import React, { useState,useEffect } from "react";
import { Accordion, Modal } from "react-bootstrap";
import "../styles/accordian.css";
import "../assets/css/Style.css";
import Coveragedependents from './Coveragedependents';
import { GetPayLoad } from "../services/PayLoadStorage";
import Cookies from "js-cookie";

const TableCard = ({ columns, rows, eventKey, activeKey, setActiveKey, variant }) => {
    const [showDependentsModal, setShowDependentsModal] = useState(false);
    const Payload = GetPayLoad('PayLoad');    

    // Set icons based on owning carrier
    let owningCarrier = Payload?.owning_carrier || '';
    const connectiCareCarrier = Cookies.get("connectiCareCarrier") || null;
    const isConnectiCareCarrier = Cookies.get("isConnectiCareCarrier") || 'false';

    const [caseIdIcon, setCaseIdIcon] = useState(null);
    const [termedIcon, setTermedIcon] = useState(null);
    const [pendingIcon, setPendingIcon] = useState(null);

    useEffect(() => {
        // When ConnectiCare carrier is set, override owningCarrier
        owningCarrier = ( isConnectiCareCarrier === 'true' && connectiCareCarrier !== null && connectiCareCarrier !== undefined) ? connectiCareCarrier : owningCarrier;
            
        import("../assets/images/Coverage/Case-Id-" + owningCarrier + ".svg").then((image) => {
            setCaseIdIcon(image.default);
        }).catch((error) => {
            import("../assets/images/Coverage/Case-Id.svg").then((image) => {
                setCaseIdIcon(image.default);
            });
        });

        import("../assets/images/Coverage/Pending-" + owningCarrier + ".svg").then((image) => {
            setPendingIcon(image.default);
        }).catch((error) => {
            import("../assets/images/Coverage/Pending.svg").then((image) => {
                setPendingIcon(image.default);
            });
        });

        import("../assets/images/Coverage/Termed-" + owningCarrier + ".svg").then((image) => {
            setTermedIcon(image.default);
        }).catch((error) => {
            import("../assets/images/Coverage/Termed.svg").then((image) => {
                setTermedIcon(image.default);
            });
        });

    }, [owningCarrier, connectiCareCarrier]);

    // Function to get dynamic image based on case status
    const getDynamicImage = () => {
        switch (rows?.dtlCaseStatus) {
            case "Issued":
                return (<img src={caseIdIcon} alt="Case" />)
            case "Termed":
                return (<img src={termedIcon} alt="Case" />)
            default:
                return (<img src={pendingIcon} alt="Case" />)
        }
    }
     

    const handleShowDependents = () => {
        setShowDependentsModal(true);
    };

    const handleCloseDependents = () => {
        setShowDependentsModal(false);
    };

    const handleAccordionClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setActiveKey(activeKey === eventKey ? null : eventKey);
    };
   

    return (
        <>
            <Accordion
                defaultActiveKey={null}
                activeKey={activeKey}
                className={`accordion-table ${variant === "coverage" ? "coverage-accordion" : ""} ${variant === "overview" ? "overview-accordion" : ""}`}
                flush
            >

                <Accordion.Item
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleAccordionClick(e);
                        }
                    }}
                    aria-expanded={activeKey === eventKey}
                    eventKey={eventKey}
                    className="accordion-card">
                    <Accordion.Header
                        className="accordion-head"
                        onClick={handleAccordionClick}
                    >
                        <div className="accordion-header-content">
                            <div className="header-text">
                                {getDynamicImage()}
                            </div>
                            <div className="header-text">
                                <span className="coveragetabcolumn me-4">{columns?.id}</span>
                                <span className="coveragetabrow">{rows?.caseId}</span>
                            </div>
                            <div className="header-text">
                                <span className="coveragetabcolumn">{columns?.plan}</span>
                                <span className="coveragetabrow">{rows?.planName}</span>
                            </div>
                            <div className="header-text">
                                <span className="coveragetabcolumn">{columns?.coverage}</span>
                                <span className="coveragetabrow">
                                {Payload?.owning_carrier === 'Q5' ? (rows?.coverageDesc?.replace(new RegExp('employee', 'gi'), 'Primary')) : rows?.coverageDesc}</span>
                            </div>
                            <div className="header-text">
                                <span className="coveragetabcolumn">{columns?.premium}</span>
                                <span className="coveragetabrow">{rows?.premiumAmt}</span>
                            </div>
                            {/* <div className="header-text">
                                <span className="coveragetabcolumn">{columns?.premium}</span>
                                <span className="coveragetabrow">{rows?.premiumAmt}</span>
                            </div>
                            <div className="header-text">
                                <span className="coveragetabcolumn">{columns?.status}</span>
                                <span className="coveragetabrow">{rows?.dtlCaseStatus}</span>
                            </div> */}
                        </div>
                    </Accordion.Header>
                    <Accordion.Body className="tablecard">
                        <div tabIndex={0} className="details-container">
                            <div className="details-item">
                                <span className="coveragebodycolumn">{columns?.product}</span>
                                <span className="coveragebodyrow">{rows?.prodType}</span>
                            </div>
                            <div className="details-item">
                                <span className="coveragebodycolumn">{columns?.memberId}</span>
                                <span className="coveragebodyrow">{rows?.memberId}</span>
                            </div>
                            <div className="details-item">
                                <span className="coveragebodycolumn">{columns?.date}</span>
                                <span className="coveragebodyrow">{rows?.planEffDate}</span>
                            </div>
                            <div className="details-item">
                                <span className="coveragebodycolumn">{columns?.termdate}</span>
                                <span className="coveragebodyrow">{rows?.termDate}</span>
                            </div>
                            <div className="details-item">
                                <label className="coveragebodycolumn">{columns?.dependents}</label>
                                <label className="coveragebodyrow">
                                    <a
                                        className={Payload?.owning_carrier === 'Q5' 
                                            ? "anchor-text anchor-text-q5" 
                                            : "text-decoration-underline"}
                                        style={{ cursor: 'pointer' }}
                                        tabIndex={0}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleShowDependents(e);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleShowDependents(e);
                                            }
                                        }}
                                    >
                                        {rows?.depClick}
                                    </a>
                                </label>
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            {/* Modal for displaying dependents */}
            <Modal className=""
                show={showDependentsModal}
                onHide={handleCloseDependents}
                scrollable={true}
                dialogClassName="modal-sm"
            >
                <Coveragedependents
                    caseData={rows}
                    onClose={handleCloseDependents}
                />
            </Modal>
        </>
    );
}

export default TableCard;